import { createApp } from "vue";
import App from "./App.vue";
import "./assets/style.css";
import router from "@/router";
import VueApexCharts from "vue3-apexcharts";




let app = createApp(App).use(router);
app.use(VueApexCharts)
// app.use(VueChartkick)

// app.use(VueGtag, {
//     property:{
//         id: window.location.host == 'localhost:8081' ? "GTM-5Z6RZKM" : "GTM-T4SPTL",
//     }
// })

app.mount("#app");